export const UserTypes={
    USER_TOKEN:'USER_TOKEN',
    USER_RFTOKEN:'USER_RFTOKEN',
    USER_SET_NAME:'USER_SET_NAME',
    USER_SET_EMAIL:'USER_SET_EMAIL',
    USER_SET_MOBILE:'USER_SET_MOBILE',
    USER_SET_ROLE:'USER_SET_ROLE',
    USER_SET_USERNAME:'USER_SET_USERNAME',
    USER_SET_USERACCESS:'USER_SET_USERACCESS',
}